import { ReactNode } from "react";
import Text from "@/shared/typography/text";

export function Title({ children }: { children: ReactNode }) {
  return (
    <Text as={"span"} type={"body2"} color={"inherit"} medium>
      {children}
    </Text>
  );
}
